var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PanelNavbar'),(_vm.$vuetify.breakpoint.mdAndUp)?_c('AppDrawer'):_vm._e(),_c('v-main',{style:({ paddingTop: _vm.$vuetify.breakpoint.smAndDown ? '100px' : '48px' })},[_vm._t("default")],2),_c('share-and-embed-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }